import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { FilterContext } from 'context/Context';
import useApi from 'helpers/api';
import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TicketsByAgentChart from './TicketsByAgentChart';

const TicketsByAgent = ({ data, filtersDash }) => {
  const { setFilters } = useContext(FilterContext);
  const navigate = useNavigate();
  const api = useApi();
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await api.agents.list('size=1000');
        if (response.content) {
          setAgents(response.content);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchAgents();
  }, []);

  const processFilterArray = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value.map(v => {
        const parsed = parseInt(v, 10);
        return isNaN(parsed) ? v : parsed;
      });
    }
    return value || '';
  };

  const handleClick = params => {
    const { name } = params;
    // Tenta encontrar pelo nome completo ou primeiro nome
    const found = agents.find(a => {
      const fullName = `${a.firstName} ${a.lastName}`.trim();
      return (
        fullName.toLowerCase() === name.toLowerCase() ||
        a.firstName.toLowerCase() === name.toLowerCase()
      );
    });

    if (found) {
      setFilters({
        page: 0,
        size: 20,
        code: '',
        priorities: filtersDash.priority || '',
        status: ['TO_DO', 'IN_PROGRESS', 'PENDING'],
        customer: processFilterArray(filtersDash.customer),
        serviceCatalog: '',
        category: '',
        subcategory: '',
        subject: '',
        agent: [parseInt(found.id)],
        serviceGroup: processFilterArray(filtersDash.serviceGroup),
        typeTicket: '',
        initialCreationDate: filtersDash.initialCreationDate || '',
        endCreationDate: filtersDash.endCreationDate || '',
        initialSolutionDate: '',
        endSolutionDate: '',
        statusSlaResponse: '',
        statusSlaSolution: '',
        createdBy: '',
        defaultFilter: ''
      });
      navigate('/tickets');
    }
  };

  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Tickets em Aberto por Agente"
        titleTag="h4"
        className="py-2"
      />
      <Card.Body as={Flex} alignItems="center" className="p-3">
        <Row className="w-100">
          <Col lg={12} xs={12}>
            <TicketsByAgentChart data={data} onClick={handleClick} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TicketsByAgent;
